export const groupNumber = (number, separator = " ") =>
	number?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator) ?? null;

export const getTranslationFromName = (name, accountLocale) => {
	if (!name) {
		return name;
	}
	const accountLocaleFirstLetters = "[" + accountLocale.substring(0, 2);
	const nameSplittedInArray = name.split("|");

	if (name.includes("[" + accountLocale + "]")) {
		const nameToDisplay = nameSplittedInArray.filter(str =>
			str.includes("[" + accountLocale + "]")
		);
		return nameToDisplay.toString().replace("[" + accountLocale + "]", "");
	} else if (name.includes(accountLocaleFirstLetters)) {
		if (accountLocaleFirstLetters === "[fr") {
			const nameToDisplay = nameSplittedInArray.filter(str =>
				str.includes("fr_FR")
			);
			return nameToDisplay.toString().substring(7);
		} else if (accountLocaleFirstLetters === "[en") {
			const nameToDisplay = nameSplittedInArray.filter(
				str => str.includes("en_GB") || str.includes("en_EN")
			);
			return nameToDisplay.toString().substring(7);
		} else if (accountLocaleFirstLetters === "[nl") {
			const nameToDisplay = nameSplittedInArray.filter(str =>
				str.includes("nl_NL")
			);
			return nameToDisplay.toString().substring(7);
		} else if (accountLocaleFirstLetters === "[de") {
			const nameToDisplay = nameSplittedInArray.filter(str =>
				str.includes("de_DE")
			);
			return nameToDisplay.toString().substring(7);
		}
		return name;
	} else {
		return name;
	}
};
export const getUnifiedLocale = locale => {
	return locale
		.replace(/en-GB|en-CA/, "en-US")
		.replace(/de-CH/, "de-DE")
		.replace(/fr-CA|fr-CH/, "fr-FR")
		.replace(/-/, "_");
};
